// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { EventEmitter } from 'events';
import { RowItemDataColorArray } from './AccountDetails/RowItemData';
export class VerticalDetailsRowItem {
    constructor(typePointer, controller) {
        this._eventEmitter = new EventEmitter();
        this.controller = controller;
        this.typePointer = typePointer;
    }
    subscribeOnUpDateEmit(callback) {
        this._eventEmitter.on('update', callback);
    }
    unsubscribeOnUpDateEmit(callback) {
        this._eventEmitter.off('update', callback);
    }
    onUpDateEmit() {
        this._eventEmitter.emit('update');
    }
    getItemColor() {
        const itemType = this.typePointer.ItemType;
        const key = this.typePointer.Key;
        const value = this.controller.getItemValue(itemType, key);
        const strValue = this.controller.getItemFormattedValue(itemType, key);
        if (strValue.isNAString()) {
            return new RowItemDataColorArray(null, this.controller.getColoringMethod(itemType));
        }
        return new RowItemDataColorArray(value, this.controller.getColoringMethod(itemType));
    }
    getItemId() {
        const groupName = this.typePointer.GroupType;
        const itemType = this.typePointer.ItemType;
        if (isValidString(this.typePointer.Key)) {
            return `${groupName}_${itemType}_${this.typePointer.Key}`;
        }
        else {
            return `${groupName}_${itemType}`;
        }
    }
    getItemName() {
        const itemType = this.typePointer.ItemType;
        const itemKey = this.typePointer.Key;
        return this.controller.getItemName(itemType, itemKey);
    }
    getItemValue() {
        const itemType = this.typePointer.ItemType;
        const itemKey = this.typePointer.Key;
        return this.controller.getItemFormattedValue(itemType, itemKey);
    }
    getItemTooltip() {
        const itemType = this.typePointer.ItemType;
        const key = this.typePointer.Key;
        return this.controller.getItemTooltip(itemType, key);
    }
    getTypePointer() {
        return this.typePointer;
    }
}
